export default {
  hero: {
    title: 'Success Stories',
    subtitle: 'Explore how we help global clients solve complex business challenges and achieve digital transformation and growth',
    imageAlt: 'Case Studies Background'
  },
  filter: {
    title: 'Dual-Dimension Case Filtering',
    regionTitle: 'Filter by Region',
    industryTitle: 'Filter by Industry',
    currentFilter: 'Current Filters',
    clearAll: 'Clear All',
    regions: {
      all: 'All Regions',
      china: 'Mainland China',
      hongkong: 'Hong Kong, China',
      taiwan: 'Taiwan, China',
      japan: 'Japan',
      korea: 'South Korea',
      singapore: 'Singapore',
      america: 'Americas',
      europe: 'Europe'
    },
    industries: {
      all: 'All Industries',
      manufacturing: 'Manufacturing',
      finance: 'Finance',
      healthcare: 'Healthcare',
      retail: 'Retail & E-commerce',
      government: 'Government & Public Services',
      professional: 'Professional Services'
    }
  },
  caseList: {
    resultCount: 'Results',
    projectBackground: 'Project Background',
    implementation: 'Implementation',
    loadMore: 'Load More Cases',
    loading: 'Loading...',
    noMore: 'No More Cases'
  },
  cases: {
    case1: {
      regionLabel: 'Japan',
      industryLabel: 'Manufacturing',
      title: 'Japan Manufacturing Hybrid Cloud Migration',
      background: 'A major Japanese automotive parts manufacturer with 12,000 employees globally and production bases in China, Thailand, and the US. Facing challenges with cross-regional data synchronization delays, high system maintenance costs, and insufficient business continuity, the company needed to build an efficient and secure hybrid cloud architecture.',
      implementation: [
        'Cross-China-Japan hybrid cloud architecture design and implementation',
        'Core business system migration to AWS cloud platform',
        'Distributed data synchronization and disaster recovery system',
        'Network architecture reconstruction and global acceleration optimization',
        '7×24 global operations support system'
      ],
      metrics: [
        { value: '40%', label: 'System Response Speed Improvement' },
        { value: '25%', label: 'Operation Cost Reduction' },
        { value: '100%', label: 'Compliance Pass Rate' }
      ]
    },
    case2: {
      regionLabel: 'Singapore',
      industryLabel: 'Finance',
      title: 'Singapore Fintech Data Security Upgrade',
      background: 'A leading payment service provider in Singapore processing over 5 million daily transactions with an annual transaction volume of S$15 billion. Facing increasingly stringent MAS (Monetary Authority of Singapore) regulatory requirements, data breach risks, and cross-border payment security challenges, the company needed to build a multi-layered data security system meeting international standards.',
      implementation: [
        'End-to-end data encryption system deployment (AES-256 standard)',
        'Multi-factor authentication and access control system',
        'Real-time threat detection and security incident response platform',
        'MAS compliance audit preparation and documentation',
        'DDoS protection and API security hardening',
        'Data backup and disaster recovery solution implementation'
      ],
      metrics: [
        { value: '95%', label: 'Security Incidents Reduction' },
        { value: '100%', label: 'MAS Compliance Audit Pass' },
        { value: '60%', label: 'Threat Response Time Reduction' }
      ]
    },
    case3: {
      regionLabel: 'South Korea',
      industryLabel: 'Healthcare',
      title: 'Korea Healthcare AI Diagnostics Platform',
      background: 'A major general hospital in Seoul with 1,200 beds and over 800,000 annual patient visits. Facing challenges with insufficient imaging diagnostic physicians, human-factor-influenced diagnostic accuracy, and long patient waiting times, the hospital needed to introduce AI technology to improve diagnostic efficiency and accuracy.',
      implementation: [
        'AI imaging analysis system deployment and customized training',
        'Medical imaging data annotation and deep learning model optimization',
        'PACS system integration and data interface development',
        'Physician training and AI-assisted diagnostic workflow design',
        'Diagnostic quality control and AI system continuous optimization'
      ],
      metrics: [
        { value: '35%', label: 'Diagnostic Accuracy Improvement' },
        { value: '70%', label: 'Image Processing Time Reduction' },
        { value: '42%', label: 'Patient Satisfaction Improvement' }
      ]
    },
    case4: {
      regionLabel: 'Hong Kong, China',
      industryLabel: 'Retail & E-commerce',
      title: 'Hong Kong Retail Group Omni-Channel Membership and Inventory Platform',
      background: 'A Hong Kong retail chain operating physical stores, online commerce, and a membership program faced inconsistent cross-channel inventory, fragmented order fulfillment visibility, disconnected customer profiles, and weak repeat-purchase analytics. The client needed a unified omni-channel retail operations platform.',
      implementation: [
        'Built an omni-channel middleware layer to unify product, inventory, order, and membership master data',
        'Deployed a customer data platform to connect store, e-commerce, campaign, and membership signals',
        'Integrated cloud POS, mobile payment, and store CRM workflows to improve frontline execution',
        'Launched warehouse-to-store visibility dashboards to optimize replenishment and transfer decisions',
        'Connected precision marketing and personalized recommendation workflows to improve loyalty operations'
      ],
      metrics: [
        { value: '32%', label: 'Inventory Accuracy Improvement' },
        { value: '28%', label: 'Repeat Purchase Growth' },
        { value: '41%', label: 'Stock-out Rate Reduction' }
      ]
    },
    case5: {
      regionLabel: 'Mainland China',
      industryLabel: 'Professional Services',
      title: 'East China Consulting Secure Knowledge Workspace',
      background: 'A regional consulting services group with delivery teams across multiple cities struggled with fragmented document versions, complex client-file permissions, delayed timesheet capture, and heavy remote collaboration needs. The firm required a unified workspace for secure collaboration, billing control, and knowledge capture.',
      implementation: [
        'Implemented a secure document management platform with granular permissions and audit trails',
        'Integrated enterprise conferencing and unified communications tools for distributed delivery teams',
        'Connected time tracking, project management, and billing systems to improve billable hour capture',
        'Automated client onboarding, contract review, and approval workflows with digital process tools',
        'Established searchable knowledge tagging and case archiving for reusable delivery experience'
      ],
      metrics: [
        { value: '68%', label: 'Document Retrieval Speed Improvement' },
        { value: '22%', label: 'Billable Hour Capture Improvement' },
        { value: '45%', label: 'Client Onboarding Cycle Reduction' }
      ]
    }
  },
  consultation: {
    title: 'Looking for the Right Solution for Your Business?',
    description: 'No matter what industry you are in or where you are located, we can provide customized digital transformation solutions. Fill out the form to get a free consultation!',
    button: 'Get Free Consultation'
  }
}
